module.exports = __webpack_public_path__ + "static/media/datasul.2ca9d283.png";